import { typesRedux } from '../../shared/types/typesRedux';

const initialState = {
    mode: '',
    logUser: undefined,
    isLoadingUser: true,
    activeStep: 0,
};

export const generalReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case typesRedux.MODE_THEME:
            return {
                ...state,
                mode: action.payload,
            };

        case typesRedux.USER_LOG:
            return {
                ...state,
                logUser: { ...action.payload },
                isLoadingUser: false,
            };

        case typesRedux.LOGOUT_LOGIN:
            return {
                ...state,
                logUser: undefined,
                isLoadingUser: false,
            };

        case typesRedux.NO_SESSION:
            return {
                ...state,
                logUser: undefined,
                isLoadingUser: false,
            };

        case typesRedux.nextStepper:
            return {
                ...state,
                activeStep: state.activeStep + 1,
            };

        case typesRedux.backStepper:
            return {
                ...state,
                activeStep: state.activeStep - 1,
            };

        case typesRedux.resetStepper:
            return {
                ...state,
                activeStep: 0,
            };

        default:
            return state;
    }
};
